module.exports = __webpack_public_path__ + "img/botprofile@3x.c55d35b1.jpg";